import React from "react";
import TagInput from "./TagInput";
import _ from "lodash";
import { startSetAlertsData } from "../actions/auth";
import { connect } from "react-redux";
import { Col, Row } from "antd";
import "../styles/components/settings.scss";
import ic_phone from "../assets/images/ic-phone.svg";
import ic_telegram from "../assets/images/ic-telegram.svg";
import ic_mail from "../assets/images/ic-mail.svg";
import ic_webhook from "../assets/images/ic-webhook.svg";
import AlertHistory from "./AlertHistory";
import Loading from "./Loading";

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deactive: true,
    };
  }

  addAlert = (type, value) => {
    const alert_channels = this.props.alert_channels;
    alert_channels[type] = [...alert_channels[type], value];

    this.startSetAlertsData(alert_channels);
  };

  removeAlert = (type, id) => {
    const alert_channels = this.props.alert_channels;

    alert_channels[type] = _.compact(
      alert_channels[type].map((el) => {
        if (id !== el.id) {
          return el;
        }
        return null;
      })
    );
    this.startSetAlertsData(alert_channels);
  };

  startSetAlertsData = (data) => {
    for (var property in data) {
      if (data.hasOwnProperty(property)) {
        data[property] = data[property].map((el) => {
          return el.value;
        });
      }
    }
    this.props.startSetAlertsData(data);
  };

  componentDidMount() {
    if (this.props.email === "demo@hamravesh.com") {
      this.setState({ deactive: true });
    } else {
      this.setState({ deactive: false });
    }
  }

  render() {
    const alert_channels = this.props.alert_channels;
    return (
      <div className="settings">
        {this.props.fetchInProgress && <Loading />}
        <div className="settings-section">
          <div className="settings-section__header">
            <h2>Alerting</h2>
            <p>When a site goes down, we will notify you</p>
          </div>
          <div
            className={`settings-section__body clearfix ${
              this.state.deactive ? "deactive" : ""
            }`}
          >
            <h4 className="bot-tip">
              You have to start messangers bot to receive alerts.
            </h4>
            <Row>
              <Col xxl={12} xl={12} lg={12} md={12} sm={24}>
                <TagInput
                  tagIcon={ic_mail}
                  label="Email address"
                  channel_type="email"
                  type="emails"
                  color="#4073DC"
                  addTag={this.addAlert}
                  placeHolder="e.g: support@hamravesh.com"
                  tags={alert_channels.emails}
                  removeTag={this.removeAlert}
                  deactive={false}
                />
              </Col>
              <Col xxl={12} xl={12} lg={12} md={12} sm={24}>
                <TagInput
                  tagIcon={ic_phone}
                  label="Phone Number"
                  channel_type="phone"
                  type="phones"
                  color="#FB5555"
                  addTag={this.addAlert}
                  placeHolder="e.g: 09121234567"
                  tags={alert_channels.phones}
                  removeTag={this.removeAlert}
                  deactive={false}
                  unVerifiedTagDesc="Please verify your phone number"
                />
              </Col>
              <Col xxl={12} xl={12} lg={12} md={12} sm={24}>
                <TagInput
                  tagIcon={ic_telegram}
                  label="Telegram"
                  channel_type="telegram_username"
                  type="telegram_usernames"
                  color="#35B2FB"
                  addTag={this.addAlert}
                  placeHolder="e.g: hamravesh"
                  tags={alert_channels.telegram_usernames}
                  tagIndicator="@"
                  removeTag={this.removeAlert}
                  deactive={false}
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <TagInput
                  secondaryDark
                  tagIcon={ic_webhook}
                  label="Web Hook"
                  channel_type="webhook"
                  type="webhooks"
                  color="#FF3D5A"
                  addTag={this.addAlert}
                  placeHolder="e.g: http://test.com/token=1234?sender=updamus"
                  tags={alert_channels.webhooks}
                  tagIndicator=""
                  removeTag={this.removeAlert}
                  deactive={false}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="settings-section">
          <div className="settings-section__header">
            <h2>History</h2>
          </div>
          <div
            className={`settings-section__body card-table clearfix ${
              this.state.deactive ? "deactive" : ""
            }`}
          >
            <AlertHistory />
          </div>
        </div>
      </div>
    );
  }
}

const format = (object) => {
  const copiedObject = Object.assign({}, object);
  for (var property in object) {
    if (object.hasOwnProperty(property)) {
      copiedObject[property] = object[property].map((el) => {
        return { id: el.value, value: el };
      });
    }
  }
  return copiedObject;
};

const mapDispatchToProps = (dispatch) => ({
  startSetAlertsData: (data) => dispatch(startSetAlertsData(data)),
});

const mapStateToProps = (state) => ({
  alert_channels: format(state.auth.alert_channels),
  email: state.auth.email,
  fetchInProgress: state.fetchInProgress,
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
